import type { PanelItem } from './types';

export const panelPrefix = 'panel_';

export const panelPropsGuard = <P extends object>(
  panel: PanelItem<P>,
): PanelItem => panel as PanelItem;
